<template>
  <CockpitDialog class="detail-dialog left-520px top-200px" title="问题详情" @close="close">
    <div class="overflow-y-auto overflow-x-hidden h-full">
      <el-form
        :model="formData"
        ref="detailForm"
        class="form-wrap mt-15px"
        label-width="120px"
        v-loading="formLoading"
      >
        <el-form-item label="问题描述" prop="description" class="desc-input">
          <el-input
            v-model="formData.description"
            size="small"
            placeholder="自动回显"
            readonly
          ></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="问题等级" prop="level">
              <el-input v-model="formData.level" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="问题图片" prop="attachmentBeford">
              <el-image
                v-if="formData.attachmentBeford"
                class="h-89px max-w-250px"
                :src="`${gxFileServer}${formData.attachmentBeford}`"
                :preview-src-list="[`${gxFileServer}${formData.attachmentBeford}`]"
              >
              </el-image>
              <el-upload
                v-else
                class="upload-demo h-89px"
                disabled
                drag
                :auto-upload="false"
                action="https://xx.yy.zz"
                :multiple="false"
                readonly
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </el-form-item>
            <el-form-item label="整改附件" prop="attachmentFileName">
              <div
                v-if="formData.attachmentFileName"
                @click="fileView"
                :title="formData.attachmentFileName"
                class="cursor-default flex items-center"
              >
                <i class="iconfont icon-bg-file mr-10px text-[#fff]"></i>
                <span class="text-[#45f2eb] inline-block truncate max-w-225px">{{
                  formData.attachmentFileName
                }}</span>
              </div>
              <el-upload
                v-else
                class="upload-demo h-89px"
                disabled
                drag
                :auto-upload="false"
                action="https://xx.yy.zz"
                :multiple="false"
                readonly
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </el-form-item>
            <el-form-item label="提出人部门" prop="createdUserDept">
              <el-input v-model="formData.createdUserDept" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="问题所属装置" prop="device">
              <el-input v-model="formData.device" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="问题所属单位" prop="organization">
              <el-input v-model="formData.organization" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="问题确认人部门" prop="confirmeDept">
              <el-input v-model="formData.confirmeDept" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarke">
              <el-input v-model="formData.remarke" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="问题分类" prop="type">
              <el-input v-model="formData.type" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="整改措施" prop="solution">
              <el-input type="textarea" v-model="formData.solution" :rows="4" readonly></el-input>
            </el-form-item>
            <el-form-item label="提出人" prop="createdUser">
              <el-input v-model="formData.createdUser" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="专业" prop="discipline">
              <el-input v-model="formData.discipline" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="关联装置位号" prop="tagCode">
              <el-input v-model="formData.tagCode" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="问题确认人" prop="confirmerUserName">
              <el-input v-model="formData.confirmerUserName" size="small" readonly></el-input>
            </el-form-item>
            <el-form-item label="计划完成时间" prop="planFinisedDate">
              <el-input
                v-model="formData.planFinisedDate"
                size="small"
                placeholder=""
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="点位位置" prop="positionObj">
              <div class="position-wrap flex">
                <el-input
                  size="small"
                  v-model="formData.positionObj.X"
                  placeholder="请选择"
                  readonly
                ></el-input>
                <el-input
                  size="small"
                  v-model="formData.positionObj.Y"
                  placeholder="请选择"
                  class="ml-5px"
                  readonly
                ></el-input>
                <el-input
                  size="small"
                  v-model="formData.positionObj.Z"
                  placeholder="请选择"
                  class="ml-5px"
                  readonly
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </CockpitDialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}

export default {
  components: { CockpitDialog },
  props: {
    problemDetail: {
      type: Object,
      default: () => {
        return {
          id: null,
        }
      },
    },
    currentChecksAndSets: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      // fileViewVisible: false,
      formLoading: false,
      formData: {
        confirmeDept: null,
        confirmerUserName: null,
        organization: null,
        description: null,
        type: null,
        attachment: null,
        attachmentBeford: null,
        createdUser: null,
        tagCode: null,
        remarke: null,
        device: null,
        handledUser: null,
        planFinisedDate: null,
        verifiedUserDept: null,
        level: null,
        solution: null,
        createdUserDept: null,
        discipline: null,
        handledUserDept: null,
        verifiedUser: null,
        attachmentFileName: null,
        positionObj: {
          X: null,
          Y: null,
          Z: null,
        },
      },
    }
  },
  watch: {
    'currentChecksAndSets.id': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getDetail()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 广西石化全场模型名称
    gxFileServer() {
      return Wiz.globalSettings.globalConfig?.gxFileServer || ''
    },
  },
  created() {
    this.getDetail()
  },
  methods: {
    // 整理详情信息
    getDetail() {
      this.formLoading = true
      let positionObj = {
        X: null,
        Y: null,
        Z: null,
      }
      if (this.currentChecksAndSets.pointId) {
        const pos = JSON.parse(this.currentChecksAndSets.position)
        positionObj = {
          X: pos[0],
          Y: pos[1],
          Z: pos[2],
        }
      }
      this.currentChecksAndSets.planFinisedDate = this.currentChecksAndSets.planFinisedDate
        ? dayjs(this.currentChecksAndSets.planFinisedDate).format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.formData = { ...this.formData, ...this.currentChecksAndSets, positionObj }
      this.formData.attachmentFileName = this.formData.attachment
        ? this.formData.attachment.substring(this.formData.attachment.lastIndexOf('/') + 1)
        : ''
      console.log('文件名称', this.formData.attachmentFileName)
      this.formLoading = false
    },
    // 文件预览
    fileView() {
      window.open(`${this.gxFileServer}${this.formData.attachment}`, '_blank')
    },
    // 关闭阀门详情弹窗
    close() {
      this.$emit('closeGxDetail', 'currentChecksAndSets')
    },
  },
  beforeDestroy() {},
}
</script>
<style lang="scss" scoped>
.detail-dialog {
  .desc-input {
    ::v-deep .el-input .el-input__inner {
      width: 725px !important;
    }
  }
  ::v-deep .el-form-item__error {
    margin-top: -5px !important;
  }
  ::v-deep .el-loading-mask {
    background: #1a4447ad !important;
  }
  .upload-demo {
    ::v-deep .el-upload-dragger {
      border-color: var(--cockpitInputBorderColor) !important;
      background: transparent !important;
      height: 89px !important;
      display: flex !important;
      flex-direction: column !important;
      width: 250px !important;
      .el-icon-upload {
        margin: 0 0 5px !important;
        color: var(--cockpitInputHoverBorderColor) !important;
      }
      .el-upload__text {
        color: #fff !important;
        em {
          color: var(--cockpitInputHoverBorderColor) !important;
        }
      }
    }
  }
  ::v-deep .el-form-item {
    margin-bottom: 10px !important;
  }
  ::v-deep .el-input .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
    width: 250px !important;
  }
  ::v-deep .el-textarea__inner {
    resize: none !important;
    width: 250px !important;
    border-color: var(--cockpitInputBorderColor) !important;
    background: transparent !important;
    color: #fff !important;
  }
  .position-wrap {
    ::v-deep .el-input {
      width: 80px !important;
      .el-input__inner {
        width: 100% !important;
        padding: 0 5px !important;
      }
    }
  }
}
</style>
